import { useLiveDraft } from "./useLiveDraft";
import { Button } from "../ui/Button";
import { Field, Form, Input } from "../ui/Field";
import { Modal } from "../ui/Overlay";
import { useT } from "../../lib/i18n";
import type { RivalDef } from "../../lib/fixtures";

/**
 * 重命名竞品列。名字是策划自己起的（「竞品A 4.43」这种带版本号的），
 * 所以不做格式校验，只挡空串——列头没有名字就认不出是哪一家。
 * 边改边存：名字非空就交给 App（随版本自动保存），空着的时候不交、标红。
 */
export function RenameRivalDialog({
  rival, onClose, onChange,
}: { rival: RivalDef; onClose: () => void; onChange: (name: string, color: string) => void }) {
  const t = useT();
  const { draft, setDraft } = useLiveDraft({ name: rival.name, color: rival.color }, (v) => onChange(v.name, v.color), {
    valid: (d) => !!d.name.trim(),
    toValue: (d) => ({ name: d.name.trim(), color: d.color }),
  });
  const { name, color } = draft;
  const setName = (v: string) => setDraft((d) => ({ ...d, name: v }));
  const setColor = (v: string) => setDraft((d) => ({ ...d, color: v }));
  const empty = !name.trim();

  return (
    <Modal
      title={t("building.renameRival")}
      width={420}
      onClose={onClose}
      footer={
        <>
          <Button tone="primary" onClick={onClose}>{t("common.done")}</Button>
        </>
      }
    >
      <Form>
        <Field label={t("dlg.rivalName")} required hint={empty ? <span className="text-danger">{t("dlg.rivalNameEmpty")}</span> : undefined}>
          <Input value={name} onChange={setName} className="w-[240px]" />
        </Field>
        <Field label={t("dlg.rivalColor")}>
          <input type="color" value={color} onChange={(e) => setColor(e.target.value)}
            className="h-control w-[52px] flex-none cursor-pointer rounded-base border border-line bg-white p-1" />
          <span className="text-xs text-ink-placeholder">{t("dlg.rivalColorHint")}</span>
        </Field>
      </Form>
    </Modal>
  );
}
